/**
 * Invoice money formatter (dollars).
 *
 * Sign-aware: a native-negative value renders `-$5.00` (sign before the currency), not
 * `$-5.00`. Shared across the billing display primitives (`InvoiceLineItems`,
 * `InvoiceTotals`) so their money formatting can't drift. Callers that store a reduction
 * as a positive number (e.g. `InvoiceTotals` discount/credit) pass the negated value.
 *
 * @module butterUI/domains/billing/formatInvoiceMoney
 */

export const formatInvoiceMoney = (n: number): string =>
  n < 0 ? `-$${Math.abs(n).toFixed(2)}` : `$${n.toFixed(2)}`
